import { render, staticRenderFns } from "./stockout.vue?vue&type=template&id=4fb7a22a&"
import script from "./stockout.vue?vue&type=script&lang=js&"
export * from "./stockout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports